import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=5f4ed674"
import script from "./approve.vue?vue&type=script&lang=js"
export * from "./approve.vue?vue&type=script&lang=js"
import style0 from "./approve.vue?vue&type=style&index=0&id=5f4ed674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports